var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-gray-500 text-sm font-normal mb-1"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"text-gray-900 font-normal text-base tracking-wide"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }